<!-- Hero Start -->
<section class="bg-half-170 bg-light d-table w-100" id="home" style="background: url('assets/images/blog/breadcrumb.png');">
    <div class="container">
        <div class="row mt-5 justify-content-center">
            <!-- <div class="col-lg-12 text-center">
                <div class="pages-heading">
                      <h2> {{currentLang === 'ar' ? blog.TiteleAr : blog.TiteleEn }}  </h2>
          <ul class="list-unstyled mt-4 mb-0">
            <li class="list-inline-item h6 date text-muted"><i class="mdi mdi-calendar-check"></i> {{blog.createDate | date : 'dd/MM/yyyy'}} </li>
          </ul>
                </div>
            </div>  -->
        </div><!--end row-->
  <div class="position-breadcrumb">
      <nav aria-label="breadcrumb" class="d-inline-block">
        <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
          <li class="breadcrumb-item"><a routerLink="/">{{'Home' | translate}}</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{'Blogs' | translate}}</li>
        </ul>
      </nav>
    </div>
    
    </div> <!--end container-->
</section><!--end section-->

<!-- Shape Start -->
<div class="position-relative">
    <div class="shape overflow-hidden text-color-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
    </div>
</div>
<!--Shape End-->

<!-- Blog STart -->
<section class="section">
    <div class="container">
     <div class="container mt-100 mt-60">
    <!-- <div class="row align-items-center mb-4 pb-4">
      <div class="col-md-8">
        <div class="section-title text-md-left">
          <h4 class="mb-4">{{'Our Blog' | translate}}</h4>
        </div>
      </div>
    </div> -->
    <!--end row-->
    <app-blog [blogData]="blogs"></app-blog>
   
    <!--end row-->
  </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>
<!--end section-->
<!-- Blog End -->

<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->